<div>
  <section Pagination (goTo)="goToPage.emit($event)" [isEnd]="isEnd" [disable-when-fetch-data]="isLoading"
    class="book-categories-section book-cur-categories-content" [class.ios-header]="device.isIOS()">
    <div class="container">
      <ng-container *ngIf="contentType; else smallItem" [ngSwitch]="contentType">
        <ng-template [ngSwitchCase]="productType.AudioBook">
          <ng-container *ngTemplateOutlet="smallItem"></ng-container>
        </ng-template>
        <ng-template [ngSwitchCase]="productType.Capsule">
          <ng-container *ngTemplateOutlet="smallItem"></ng-container>
        </ng-template>
        <ng-template [ngSwitchCase]="productType.AudioSeries">
          <ng-container *ngTemplateOutlet="largItem"></ng-container>
        </ng-template>
        <ng-template [ngSwitchCase]="productType.Podcast">
          <ng-container *ngTemplateOutlet="largItem"></ng-container>
        </ng-template>
      </ng-container>
    </div>
  </section>
  <ng-template #smallItem>
    <ng-template [ngIf]="items.length" [ngIfElse]="loading">
      <div class="smallItem">
        <ng-template ngFor [ngForOf]="items" let-item let-idx="index" [ngForTrackBy]="trackBy">
          <div (click)="goToBook(item.identifier, idx)" class="wrapper-item">
            <div class="item-img small-item-img" style="vertical-align: bottom;">
              <img [lazySrc]="
                                            IMAGE_URL +
                                            '/content/books/' +
                                            item.audioBookId +
                                            '/pic.jpg?w=250&h=250&mode=stretch&t=' +
                                            item.recordVersion
                                          " lazySrcVisible="visible" loading="lazy" src="assets/img/placeholder.png">
              <div class="discount-badge" *ngIf="
                                    item.products &&
                                    item.products.length > 0 &&
                                    item.products[0] &&
                                    item.products[0].price &&
                                    item.products[0].price != item.products[0].discountedPrice
                                 ">
                %
                <span [textContent]="item.products[0].discount.promotionValue * 100 | number: '1.0-0' "></span>
              </div>
            </div>
            <div class="item-text truncate">
              <span class="item-name truncate-text" [textContent]="item.title"></span>
              <!-- <span class="more-vert" *ngIf="showIcon">
                                      <navaar-more-vert-icon></navaar-more-vert-icon>
                                    </span> -->
              <ng-container *ngIf="item.authors">
                <div class="box-authors" *ngIf="item.authors.length > 0">
                  <span [textContent]="item.authors | combineMultipleName" class="item-author"></span>
                </div>
              </ng-container>
              <ng-container *ngIf="item.narrators">
                <div class="box-authors" *ngIf="item.narrators.length > 0">
                  <span [textContent]="item.narrators | combineMultipleName" class="item-author"></span>
                </div>
              </ng-container>
              <span class="rate-number" *ngIf="item.rating"
                [textContent]="item.rating.average ? item.rating.average : '--'"></span>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </ng-template>
  <ng-template #largItem>
    <ng-template [ngIf]="items.length" [ngIfElse]="loading">
      <div class="largItem">
        <ng-template ngFor [ngForOf]="items" let-item let-idx="index" [ngForTrackBy]="trackBy">
          <div class="wrapper-item">
            <div class="item-img larg-item-img" (click)="goToBook(item.identifier, idx)">
              <img
                [lazySrc]="IMAGE_URL + '/content/books/' + item.audioBookId +'/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion "
                lazySrcVisible="visible" loading="lazy" src="assets/img/placeholder.png">
              <div class="discount-badge" *ngIf="
                                    item.products &&
                                    item.products.length > 0 &&
                                    item.products[0] &&
                                    item.products[0].price &&
                                    item.products[0].price != item.products[0].discountedPrice
                                 ">
                %
                <span [textContent]="item.products[0].discount.promotionValue * 100 | number: '1.0-0' "></span>
              </div>
            </div>
            <!-- <div
                            class="display-order"
                            [textContent]="item.displayOrder"
                            (click)="goToBook(item.identifier, idx)"
                        ></div> -->
            <div class="item-text truncate" (click)="goToBook(item.identifier, idx)">
              <span class="item-name truncate" [textContent]="item.title"></span>
              <div class="box-player">
                <span class="rate-number" *ngIf="item.rating"
                      [ngClass]="{'rate-number-relative': contentType === productType.Podcast}"
                  [textContent]="item.rating.average ? item.rating.average : '--'"></span>
                <span class="date" [textContent]="item.webPublicationDate | convertDateTimeToDayAgo"
                  *ngIf="contentType != productType.Podcast"></span>
                <span class="duration" [textContent]="item.duration"></span>
              </div>
            </div>
<!--            <span class="icon-play">-->
<!--              <navaar-small-player-icon [show-loader]="item.showPlayer" (click)="playAudioBook(item.identifier, item)">-->
<!--              </navaar-small-player-icon>-->
<!--            </span>-->
          </div>
        </ng-template>
      </div>
    </ng-template>
  </ng-template>
  <ng-template #loading>
    <div class="container">
      <ng-template ngFor [ngForOf]="[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]" let-item>
        <div class="catalog-page-item">
          <div class="cur-catalog-new-page-img catalog-new-page-list">
            <img src="assets/icon-new/empty-book.svg" class="wrapper-img-slider">
          </div>
          <div class="cur-catalog-new-page-txt truncate">
            <span class="cur-catalog-new-page-name"></span>
            <span class="cur-catalog-new-page-author"></span>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>
